"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeDefinitionFor = void 0;
var tslib_1 = require("tslib");
var joi_to_swagger_1 = tslib_1.__importDefault(require("joi-to-swagger"));
var query_parameters_from_joi_object_1 = require("./query.parameters.from.joi.object");
var makeDefinitionFor = function (url, info, allResponses) {
    var _a, _b;
    var responses = {};
    allResponses.forEach(function (res) {
        var _a;
        responses[res.code] = {
            description: res.description,
            content: (_a = {},
                _a[res.hasOwnProperty('responseType') ? res.responseType : 'application/json'] = {
                    schema: (0, joi_to_swagger_1.default)(res.schema).swagger,
                },
                _a),
        };
    });
    var parameters = info.params || [];
    parameters.push({ $ref: '#/components/parameters/ikeRequester' });
    return _a = {},
        _a[url] = (_b = {
                parameters: parameters
            },
            _b[info.method] = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ summary: info.summary, description: info.description }, (info.hasOwnProperty('requestBody') && (0, query_parameters_from_joi_object_1.makeQueryParametersFromJoiObject)(info.requestBody))), (info.hasOwnProperty('tags') && { tags: info.tags })), { responses: responses }),
            _b),
        _a;
};
exports.makeDefinitionFor = makeDefinitionFor;
//# sourceMappingURL=endpoint.definition.details.generator.js.map